import { actionSheetController } from '@ionic/vue'

export default {
  individual: [
    {
      key: 'userName',
      label: '个人姓名',
      isRequired: true,
      type: 'text'
    },
    {
      key: 'idCard',
      label: '公民身份号码',
      isRequired: true,
      type: 'text'
    },
    {
      key: 'userSex',
      label: '性别',
      isRequired: true,
      type: 'actionSheet',
    },
    {
      key: 'birthdayStr',
      label: '出生年月日',
      isRequired: true,
      type: 'date'
    },
    {
      key: 'nation',
      label: '民族',
      isRequired: true,
      type: 'actionSheet'
    },
    {
      key: 'address',
      label: '住址',
      isRequired: true,
      type: 'text'
    },
    {
      key: 'email',
      label: '邮箱',
      isRequired: false,
      type: 'text'
    }
  ],
  enterprise: [
    {
      key: 'creditCode',
      label: '统一社会信用代码',
      isRequired: true,
      type: 'text'
    },
    {
      key: 'orgName',
      label: '企业名称',
      isRequired: true,
      type: 'text'
    },
    {
      key: 'legalRepresentative',
      label: '法定代表人姓名',
      isRequired: true,
      type: 'text'
    },
    {
      key: 'mobilePhone',
      label: '法定代表人联系方式',
      isRequired: true,
      type: 'text'
    },
    {
      key: 'residence',
      label: '企业住所地',
      isRequired: true,
      type: 'text'
    },
    {
      key: 'legalRepresentativeEmail',
      label: '法定代表人邮箱',
      isRequired: false,
      type: 'text'
    },
    {
      key: 'orgType',
      label: '组织类型',
      isRequired: false,
      type: 'text',
      isHide: true,
      value: 1
    }
  ],
  lawyer: [
    {
      key: 'lawyerLicense',
      label: '律师执业证号',
      isRequired: true,
      type: 'text'
    },
    {
      key: 'userName',
      label: '律师姓名',
      isRequired: true,
      type: 'text'
    },
    {
      key: 'idCard',
      label: '律师公民身份号码',
      isRequired: true,
      type: 'text',
    },
    {
      key: 'email',
      label: '律师邮箱',
      isRequired: false,
      type: 'text'
    }
  ],
  lawOffice: [
    {
      key: 'lawyerLicense',
      label: '律师执业证号',
      isRequired: true,
      type: 'text'
    },
    {
      key: 'userName',
      label: '律师姓名',
      isRequired: true,
      type: 'text'
    },
    {
      key: 'idCard',
      label: '律师公民身份号码',
      isRequired: true,
      type: 'text',
    },
    {
      key: 'creditCode',
      label: '律所统一社会信用代码(18位数字)',
      isRequired: true,
      type: 'text'
    },
    {
      key: 'orgName',
      label: '律所名称',
      isRequired: true,
      type: 'text'
    },
    {
      key: 'residence',
      label: '律所住所',
      isRequired: true,
      type: 'text',
    },
    {
      key: 'legalRepresentative',
      label: '律所负责人名字',
      isRequired: true,
      type: 'text'
    },
    {
      key: 'mobilePhone',
      label: '律所负责人联系方式',
      isRequired: true,
      type: 'text',
    },
    {
      key: 'legalRepresentativeEmail',
      label: '律所负责人邮箱',
      isRequired: false,
      type: 'text'
    },
    {
      key: 'orgType',
      label: '组织类型',
      isRequired: false,
      type: 'text',
      isHide: true,
      value: 2
    }
  ],
}